import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=f12563fa&scoped=true&"
import script from "./Property.vue?vue&type=script&lang=js&"
export * from "./Property.vue?vue&type=script&lang=js&"
import style0 from "./Property.vue?vue&type=style&index=0&id=f12563fa&lang=less&scoped=true&"
import style1 from "./Property.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12563fa",
  null
  
)

export default component.exports